module.exports = __webpack_public_path__ + "img/logo-teamtip.28119b65.svg";